import React from 'react';

export const PhotoPlaceholder = ({ label }) => (
    <div className="ph" role="img" aria-label={label}>
        <svg width="28" height="28" viewBox="0 0 256 256" aria-hidden="true">
            <rect x="32" y="56" width="192" height="144" rx="12" fill="none" stroke="#9394B0" strokeWidth="12" />
            <circle cx="128" cy="128" r="36" fill="none" stroke="#9394B0" strokeWidth="12" />
        </svg>
        <span>{label}</span>
    </div>
);
